export default "__VITE_ASSET__DFpnkyNC__"